import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormControlService, SetService, JwtService } from "ngx-block-core";
import { fileType, fileUploadType } from "../../../data/data";
import { NzMessageService,UploadFile } from 'ng-zorro-antd';
import { Observable, Observer } from 'rxjs';

@Component({
    selector: 'app-sucu04-weiget0030002',
    templateUrl: './sucu04-weiget0030002.component.html',
})
export class Sucu04Weiget0030002Component implements OnInit {
    @Input() local = false;
    @Input() static = false;
    @Input() blockid = "-1";
    @Input() layoutid = "-1";
    @Input() form: FormGroup;
    @Input() nzFormGroupData;
    @Input() nzLayout = 'horizontal'
    previewImage: string | undefined = '';
    previewVisible = false;
    previewLength = 1;
    iconShow = false;
    fileList = [];
    udpateflag = true;
    @Input() sets = {
        blockCode: "sucublock45",
        blockId: "",
        layoutId: "",
        blockType: 'formBlock',
        blockChildType: '',
        versionCode: 4,
        attributes: ['form', 'nzFormGroupData', 'nzLayout'],
        styles: {
            nzText: "上传",
            nzAccept: "",
            nzListType: "file",
            uploadNum: 1,
            nzSize: "default",
            nzLayout: {
                nzLayout1: 0,
                nzLayout2: 8,
                nzLayout3: 0,
                nzLayout4: 16,
                nzAlign: 'left',
                nzMarginBottom: 3,
                nzLineHeight: 1.4,
                nzFontSize: 12
            },
            nzRequired: false,
            nzHasFeedback: true,
            nzReadOnly: false,
        },
        datas: {
            nzAction: "v1/photoUpload",
            nzUploadType: ""

        }
    };
    setData = []
    value = "";
    constructor(
        public setService: SetService,
        private formControlService: FormControlService,
        private jwtService: JwtService,
        private msg: NzMessageService
    ) { }

    ngOnInit() {
        this.baseInit();

        this.autoUpdate();



        let control_name = this.nzFormGroupData.nzKey;
        this.form.get(control_name).valueChanges.pipe(

        ).subscribe((val) => {
            console.log("表单变更", val);
            if (this.udpateflag && typeof val != "undefined" && val != "") {

                console.log("还原数据", val);
                let fileHandle = JSON.parse(val);
                //处理路径
                fileHandle.forEach(element => {
                    element.url = this.jwtService.getUserResourceUrl() + element.response[0].fileUrl;

                });
                this.fileList = fileHandle;


                console.log("当前场景图片数据", this.fileList)
                // this.udpateflag = false;
            }


        });

        this.Listening();
    }
    autoUpdate() {

        //v3,升级自定义表单参数
        if (this.sets.versionCode < 3) {

            this.sets.blockCode = "sucublock45";

            this.sets.versionCode = 3;
        }
        //v3,升级自定义表单参数
        if (this.sets.versionCode < 4) {

            this.sets.styles.nzReadOnly =false;

            this.sets.versionCode = 4;
        }

        

    }
    setDataInit() {
        this.setData = [
            {
                tabName: '数据',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            { name: 'nzFormDataSource' },

                            {
                                name: 'select',
                                inputs: { nzText: "存储类型 : ", nzKeys: ['datas', 'nzUploadType',], nzData: fileUploadType },
                            },
                        ]
                    }
                ]
            },
            {
                tabName: '样式',
                datas: [
                    {
                        type: 'styles',
                        data: [
                            {
                                name: 'input',
                                inputs: { nzText: "按钮名称 : ", nzKeys: ['styles', 'nzText']},
                            },
                            {
                                name: 'select',
                                inputs: { nzText: "文件类型 : ", nzKeys: ['styles', 'nzAccept',], nzData: fileType, nzMode: 'multiple' },
                            },
                            {
                                name: 'select',
                                inputs: { nzText: "样式选择 : ", nzKeys: ['styles', 'nzListType',], nzData: [{ value: 'picture-card', label: '图片类型' }, { value: 'file', label: '文件类型' }] },
                            },
                            {
                                name: 'number',
                                inputs: { nzText: "上传数量 : ", nzKeys: ['styles', 'uploadNum'] },
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] }
                              },
                        ]
                    }

                ]
            },

            {
                tabName: '表单',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            { name: 'nzFormSet' },
                        ]
                    }
                ]
            }
        ]
    }
    baseInit() {

        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;
                // this.nzFormGroupData['nzSearchDataType'] = "??";
                // if (this.nzFormGroupData['nzSearchType'] == 'null')
                //     this.nzFormGroupData['nzSearchType'] = "=";
                this.setDataInit();
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }

                this.pzListening()
            }
            else {//静态
                if (typeof this.sets == "string")
                    this.sets = JSON.parse(<any>this.sets);
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
            }
        }
    }
    ngOnDestroy() {
        if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
    }


        Listening() {
            console.log("Listening", this.blockid)
            setTimeout(() => {
              this.setService.initEvent(this.blockid);
              this.setService.events[this.blockid].subscribe(
                data => {
                  console.log("data", JSON.stringify(data))
                  switch (data['type']) {
                    case 'reset':
                        this.fileList=[];
                        this.form.get(this.nzFormGroupData.nzKey).patchValue("");
                      break;
        
                    default:
                      break;
                  }
        
        
                }
              )
            }, !this.static ? 100 : 0);
        
        
          }
    pzListening() {
        setTimeout(() => {
            this.setService.initEvent(this.blockid, 'pz');
            this.setService.pzEvents[this.blockid].subscribe(data => {
                switch (data['type']) {
                    case 'changeFormValid':
                        this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
                        break;

                    default:
                        break;
                }
            }
            )
        }, 100);

    }
    beforeUpload = (file: File) => {
        return new Observable((observer: Observer<boolean>) => {
            //   const isJPG = file.type === 'image/jpeg';
            //   if (!isJPG) {
            //     this.msg.error('You can only upload JPG file!');
            //     observer.complete();
            //     return;
            //   }
            const isLt2M = file.size / 1024 / 1024 < 10;
            console.log("图片尺寸",isLt2M)
            if (!isLt2M) {
                this.msg.error('图片文件大小不能超过10M!');
                observer.complete();
                return;
            }else{
                observer.next(isLt2M);
                observer.complete();
            }

        });
    };
    /*Base64转换 */
    private getBase64(img: File, callback: (img: string) => void): void {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result!.toString()));
        reader.readAsDataURL(img);
    }
    handleChange(info: any): void {
        if (info.length != 0) {

            //路径
            if (this.sets.datas.nzUploadType == '0') {
                if (info.file.response) {
                    //this.value = info.file.response[info.file.response.length - 1].fileUrl;
                    let newFileList = [];
                    this.fileList.forEach(element => {
                        console.log("当前数据监测", element);
                        let item = {
                            uid: element.uid,
                            name: element.name,
                            response: [{
                                fileType: element.response[0].fileType,
                                fileUrl: element.response[0].fileUrl
                            }]
                        }
                        newFileList.push(item);

                    });

                    this.value = JSON.stringify(newFileList)
                    console.log("newFileList", newFileList);
                    console.log("当前图片list数据", this.fileList);

                }
                //base64
            } else if (this.sets.datas.nzUploadType == '1') {
                this.getBase64(info.file!.originFileObj!, (img: string) => {
                    console.log("图片base64", img);
                    this.value = img;
                });
            } else {

            }



        }


    }
    handlePreview = (file: UploadFile) => {
        this.previewImage = file.url || file.thumbUrl;
        this.previewVisible = true;
      };

}
